// Session roles belong to the active tenant. Never cache administrator authority
// across tenant changes, or require a per-resource grant for this role.
export const isTenantAdministrator = user => Boolean(user?.roles?.some(role => role.key === 'ADMINISTRATOR'));
